import { ApiError } from '../types/api.js'

export interface FieldErrors {
  name?: string
  slug?: string
  description?: string
  categoryId?: string
  price?: string
  weight?: string
  calories?: string
  protein?: string
  fat?: string
  carbohydrates?: string
  oldPrice?: string
  sku?: string
  imageUrl?: string
  composition?: string
  min?: string
  max?: string
  maxQuantity?: string
  sortOrder?: string
  general?: string
}

const VALIDATION_CODES = new Set(['VALIDATION_ERROR', 'SLUG_REQUIRED', 'CONFLICT'])

function isValidationError(err: unknown): err is ApiError {
  return err instanceof ApiError && (VALIDATION_CODES.has(err.code) || err.status === 400)
}

export function toFieldErrors(
  err: unknown,
  fields: Array<keyof FieldErrors>,
  fallback: string,
): FieldErrors {
  if (isValidationError(err) && err.details && typeof err.details === 'object') {
    const fieldErrors: FieldErrors = {}
    for (const [field, msg] of Object.entries(err.details)) {
      if (fields.includes(field as keyof FieldErrors)) {
        fieldErrors[field as keyof FieldErrors] = String(msg)
      }
    }
    if (Object.keys(fieldErrors).length > 0) return fieldErrors
  }
  if (err instanceof ApiError) {
    return { general: err.message || fallback }
  }
  return { general: fallback }
}